export default Object.freeze({
    urlThumbnailDefault: 'https://secure.gravatar.com/avatar/8fbf5ffda6230029170d4bf05c9f332a?s=140&d=mm',
})
